export default "__VITE_ASSET__CAwhLPKU__"